import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLoading } from "context/LoadingContext";
import { useAlert } from "context/AlertContext";
import { fetchDashboardData } from "Service/ApiService"; // Replace with your API

const DashboardController = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const { setLoading } = useLoading();
  const { showAlert } = useAlert();
  const vendorDetails = JSON.parse(localStorage.getItem("vendor"));
  const vendorCode = vendorDetails ? vendorDetails.vendorCode : null;

  // Fetch dashboard data on mount
  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = async () => {
    try {
      setLoading(true);
      const response = await fetchDashboardData(vendorCode);
      if (response && response.success) {
        setDashboardData(response.data || []);
      } else {
        showAlert("Failed to fetch dashboard data!", { icon: "error", title: "Error" });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showAlert("Something went wrong while fetching dashboard data!", {
        icon: "error",
        title: "Error",
      });
    }
  };

  return {
    dashboardData,
  };
};

export default DashboardController;
